import { useEffect } from 'react';

type UseWindowFocusProps = {
    onFocus: () => void;
};

export const useWindowFocus = ({ onFocus }: UseWindowFocusProps) => {
    useEffect(() => {
        const handleFocus = () => {
            onFocus();
        };

        window.addEventListener('focus', handleFocus);

        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, [onFocus]);
};
